// Safari rejects ready/finished of a skipped cross-document view transition (bfcache restore,
// quick re-navigation) and nothing else holds those promises: unhandled rejections (Overhub 6726eaa7).
// Must run before first render, so it is a classic blocking script in <head>, not a module.
(function () {
  function hold(event) {
    var transition = event.viewTransition;
    if (!transition) return;
    [transition.ready, transition.finished, transition.updateCallbackDone].forEach(function (p) {
      if (p) p.catch(function () {});
    });
  }
  addEventListener("pagereveal", hold);
  addEventListener("pageswap", hold);
})();
